import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "file-excel-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7 2.25C5.48079 2.25 4.25 3.48079 4.25 5V19C4.25 20.5192 5.48079 21.75 7 21.75H17C18.5192 21.75 19.75 20.5192 19.75 19V7.828C19.75 7.09886 19.4598 6.39916 18.9443 5.88367L16.1163 3.05567C15.6008 2.54018 14.9011 2.25 14.172 2.25H7ZM5.75 5C5.75 4.30921 6.30921 3.75 7 3.75H14.172C14.5029 3.75 14.8212 3.88182 15.0557 4.11633L17.8837 6.94433C18.1182 7.17884 18.25 7.49714 18.25 7.828V19C18.25 19.6908 17.6908 20.25 17 20.25H7C6.30921 20.25 5.75 19.6908 5.75 19V5ZM10.0113 10.916C10.3258 10.6465 10.7993 10.6829 11.0688 10.9974L12 12.0838L12.9312 10.9974C13.2008 10.6829 13.6743 10.6465 13.9887 10.916C14.3032 11.1856 14.3397 11.6591 14.0701 11.9736L12.9878 13.2362L14.0701 14.4988C14.3397 14.8133 14.3032 15.2868 13.9887 15.5564C13.6743 15.8259 13.2008 15.7895 12.9312 15.475L12 14.3886L11.0688 15.475C10.7993 15.7895 10.3258 15.8259 10.0113 15.5564C9.69682 15.2868 9.66039 14.8133 9.92996 14.4988L11.0122 13.2362L9.92996 11.9736C9.66039 11.6591 9.69682 11.1856 10.0113 10.916Z"
    }, null, -1)
  ])))
}
export default { render: render }